
export default function CTA() {
  return (
    <section className="bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-700 py-12 sm:py-16 lg:py-24 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Icon */}
        <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6 sm:mb-8">
          <i className="ri-tools-fill text-white text-3xl sm:text-4xl"></i>
        </div>

        {/* Heading */}
        <h2 className="text-2xl sm:text-3xl lg:text-5xl font-extrabold text-white mb-4 sm:mb-6 leading-tight px-2">
          Votre Fenêtre a Besoin d'une Réparation ?
        </h2>

        {/* Subheading */}
        <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-3 sm:mb-4 max-w-3xl mx-auto leading-relaxed px-4">
          <strong>Nous ne vendons pas de fenêtres neuves.</strong> Nous réparons les vôtres pour prolonger leur durée de vie de 10 à 15 ans. Découvrez nos <a href="#services" className="text-amber-300 hover:text-amber-200 underline font-medium">services de réparation</a>.
        </p>
        
        <p className="text-sm sm:text-base lg:text-lg text-white/80 mb-8 sm:mb-10 max-w-2xl mx-auto px-4">
          <a href="#contact" className="text-amber-300 hover:text-amber-200 underline font-medium">Diagnostic gratuit</a> • Réparation le jour même dans 85% des cas • 3 à 5x moins cher qu'un remplacement
        </p>

        {/* CTA Buttons - OPTIMIZED FOR MOBILE */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center max-w-lg sm:max-w-none mx-auto px-4">
          <a
            href="#contact"
            className="bg-white text-teal-700 px-8 sm:px-10 py-4 sm:py-4.5 rounded-full font-bold text-base sm:text-lg hover:bg-gray-100 transition-all hover:shadow-2xl hover:-translate-y-1 inline-flex items-center justify-center space-x-2 sm:space-x-3 whitespace-nowrap cursor-pointer w-full sm:w-auto active:scale-95"
          >
            <i className="ri-tools-line text-xl sm:text-2xl"></i>
            <span>Demander une Réparation</span>
          </a>
          <a
            href="tel:0980803684"
            className="bg-transparent border-2 border-white text-white px-8 sm:px-10 py-4 sm:py-4.5 rounded-full font-bold text-base sm:text-lg hover:bg-white hover:text-teal-700 transition-all inline-flex items-center justify-center space-x-2 sm:space-x-3 whitespace-nowrap cursor-pointer w-full sm:w-auto active:scale-95"
          >
            <i className="ri-phone-line text-xl sm:text-2xl"></i>
            <span>Appeler Maintenant</span>
          </a>
        </div>

        {/* Trust Badges - OPTIMIZED FOR MOBILE */}
        <div className="mt-8 sm:mt-12 flex flex-wrap justify-center gap-4 sm:gap-6 lg:gap-8 text-white/90 px-4">
          <div className="flex items-center space-x-2">
            <i className="ri-time-line text-xl sm:text-2xl"></i>
            <span className="text-xs sm:text-sm font-medium">Intervention sous 24h</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-shield-check-line text-xl sm:text-2xl"></i>
            <span className="text-xs sm:text-sm font-medium">Garantie 2 ans</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-money-euro-circle-line text-xl sm:text-2xl"></i>
            <span className="text-xs sm:text-sm font-medium">Devis gratuit</span>
          </div>
        </div>
      </div>
    </section>
  );
}
